import { createTheme } from "@mui/material/styles";
import "./../styles/fonts.css";

export const Colors = {
  normalChip: "rgb(0, 70, 79)",
  green: "#19857b",
  headerBgColor: "#1976d2",
};

const EGITheme = createTheme({
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          backgroundColor: "var(--aqua-1)",
        },
      },
    },

    MuiMenu: {
      styleOverrides: {
        paper: {
          color: "var(--aqua-9)",
          borderRadius: "8px",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.3)", // Soft shadow
        },
        list: {
          padding: "10px 10px 10px 10px", // Adjust menu list padding
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: "var(--aqua-9)", // Text color
          fontSize: "16px",
          fontWeight: "500",
        },
      },
    },

    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "var(--aqua-9)",
          minWidth: "50px",
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "30px",
          // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#fff",
          "& fieldset": {
            borderColor: "#ddd",
          },
          // "&:hover fieldset": {
          //   borderColor: "var(--aqua-2) !important", // Border color on hover
          // },
          "&.Mui-focused fieldset": {
            borderColor: "var(--aqua-6) !important", // Aqua border color when focused
          },
          // "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
          //   borderColor: "#d3d3d3 !important",
          //   backgroundColor: "var(--gray-2) !important",
          // },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#aaa", // Default label color
          "&.Mui-focused": {
            color: "var(--aqua-6) !important", // Aqua label color when focused
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            // backgroundColor: "var(--gray-1) !important",
            backgroundColor: "#f5f5f5 !important",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "30px",
          textTransform: "none",
          padding: "12px",
          fontSize: "16px",
          textAlign: "center",
          fontWeight: 500,
          "&.Mui-disabled": {
            color: "var(--gray-4)", // Text color of the disabled button
            backgroundColor: "var(--gray-2)", // Background color of the disabled button
          },
        },
        contained: {
          backgroundColor: "var(--aqua-8) !important",
          "&:hover": {
            backgroundColor: "var(--aqua-9) !important",
          },
          "&.Mui-disabled": {
            backgroundColor: "var(--gray-2) !important", // Ensures disabled contained buttons get the correct background
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          fontSize: "16px",
          color: "var(--aqua-9)", // Label color
          fontWeight: "bold",
        },
        label: {
          fontSize: "16px",
          color: "var(--aqua-9)",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "var(--aqua-9)",
          "&.Mui-checked": {
            color: "var(--aqua-9)",
          },
          "&.Mui-disabled": {
            color: "var(--gray-3)",
          },
        },
      },
    },
  },
  typography: {
    fontFamily: "'GT Walsheim', sans-serif",
    body1: {
      // color: "var(--gray-3) !important",
      fontSize: "13px",
      lineHeight: "16px",
    },
  },
});

export default EGITheme;
